import { useRef } from 'react';

import { useModal } from 'mui-modal-provider';

import { ShowModalOutput } from '@cast/design-system';

import { OnboardingConnectMethod } from '@oneclick/constants/onboarding';
import { ConnectionChoice } from '@oneclick/pages/onboarding/_constants';

import {
  ConnectionFlow,
  ConnectionFlowProps,
} from './_components/ConnectionFlow';

const METHOD_TO_CHOICE: Record<OnboardingConnectMethod, ConnectionChoice> = {
  cloud: ConnectionChoice.cloudConnect,
  snapshot: ConnectionChoice.snapshot,
  single: ConnectionChoice.single,
};

type ConnectClusterDialogProps = {
  initialChoice?: ConnectionChoice;
  onClose: () => void;
};

const ConnectClusterDialog = ({
  initialChoice = ConnectionChoice.cloudConnect,
  onClose,
}: ConnectClusterDialogProps) => (
  <ConnectionFlow
    layout="dialog"
    initialChoice={initialChoice}
    onClose={onClose}
    onSuccess={onClose}
    showSkipForNow={false}
  />
);

export const useConnectClusterDialog = () => {
  const { showModal } = useModal();
  const modalRef = useRef<ShowModalOutput | undefined>(undefined);

  const openConnectClusterDialog = (
    options?: Pick<ConnectionFlowProps, 'initialChoice'> & {
      method?: OnboardingConnectMethod;
    }
  ) => {
    modalRef.current?.destroy();
    modalRef.current = showModal(ConnectClusterDialog, {
      initialChoice:
        options?.initialChoice ??
        (options?.method
          ? METHOD_TO_CHOICE[options.method]
          : ConnectionChoice.cloudConnect),
      onClose: () => {
        modalRef.current?.destroy();
        modalRef.current = undefined;
      },
    });
  };

  return { openConnectClusterDialog };
};
